<!--
 * @Author: zhaozemin zemin.zhao@allianz.com
 * @Date: 2024-10-30 10:53:26
 * @LastEditors: zhaozemin zemin.zhao@allianz.com
 * @LastEditTime: 2025-07-23 16:28:14
 * @FilePath: \b2c-pc-web\src\components\Footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="footer" style="margin-top:140px;">
    <div class="w1400">
      <div style="padding-top: 92px;">
        <a @click="maskFn('xkz')" href="javascript:;">保险经纪业务许可证</a>|
        <a @click="maskFn('yyzz')" href="javascript:;">营业执照</a>|
        <a @click="gotoPage('cookie')" href="javascript:;">隐私政策</a>|
        <a @click="gotoPage('legal')" href="javascript:;">法律声明</a>|
      </div>
      <div
        style="display: flex;
        align-items: center;
        justify-content: center;"
      >
        <a
          style=""
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042461"
          >京ICP备16004451号-1</a
        >
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042461"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          ><img
            src="../assets/image/gongan.png"
            style="float:left;"
          />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            京公网安备 11010502042461
          </p>
        </a>
      </div>
    </div>
    <div v-if="mask" @click="maskFn()" class="mask">
      <div v-if="mask == 'xkz'" class="xkz"></div>
      <div v-if="mask == 'yyzz'" class="yyzz"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      mask: null
    };
  },
  methods: {
    gotoPage(link) {
      this.$router.push({ path: link });
    },
    maskFn(index) {
      this.mask = index || null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue